"use client"
import { Badge, Box, Button, Card, Flex, Heading, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { FiClock, FiTarget, FiUsers } from 'react-icons/fi';
import { LuCheck } from 'react-icons/lu';
import { NavLink } from 'react-router-dom';

const offers = [
  {
    title: "Kreatywne mikrogrupy",
    description: "Rozumiesz po części szkolne tematy, ale potrzebujesz, żeby ktoś pomógł Ci je uporządkować? Zamiast nudy w ławce wolisz ruchowe gry edukacyjne i quizy tematyczne? Chcesz uczyć się lepiej i skuteczniej? Jeśli tak, to zajęcia grupowe będą dla Ciebie idealnym rozwiązaniem! Wyjaśnimy Ci kluczowe zagadnienia i najważniejsze zasady oraz podpowiemy co zrobić, aby ta wiedza została z Tobą na dłużej. A wszystko to w przyjaznej atmosferze współpracy i twórczego współdziałania.",
    price: "Od 79 zł/h",
    benefits: [
      "Kreatywne, nowoczesne i angażujące metody",
      "Małe grupy - uwaga poświęcona każdemu uczniowi",
      "Doskonała alternatywa dla zajęć indywidualnych",
    ],
    details: [
      { icon: FiTarget, value: "10+ lat" },
      { icon: FiUsers, value: "2-6" },
      { icon: FiClock, value: "60 min" },
    ],
    featured: true,
    slug: "grupowe",
  },
  {
    title: "Korepetycje indywidualne",
    description: "Korepetycje indywidualne to dobry wybór dla tych, którzy chcą osiągnąć swój cel bez żadnych kompromisów. Doświadczony korepetytor pomoże Ci nadrobić zaległości, zrozumieć koncept albo przygotować się do egzaminu, a tempo i zakres materiału będzie dostosowane w 100% do Twoich potrzeb.",
    price: "Od 135 zł/h",
    benefits: [
      "Maksymalnie skrojone do Twoich potrzeb",
      "Opanujesz bieżący materiał i uzupełnisz braki",
      "Dowolna forma - stacjonarna lub online",
    ],
    details: [
      { icon: FiTarget, value: "8+ lat" },
      { icon: FiUsers, value: "1" },
      { icon: FiClock, value: "60/90 min" },
    ],
    featured: false,
    slug: "indywidualne",
  },
]

export default function HomeLessons() {
  return (
    <Box id="korepetycje" as="section" py="16" px={{ base: "4", md: "8" }}>
      <Flex direction="column" gap="8" maxW="7xl" mx="auto">
        <Stack gap="3" maxW="2xl">
          <Text color="brand.orange.500" fontSize='xl' fontWeight="semibold" textTransform="uppercase" letterSpacing="wider">
            Oferta korepetycji
          </Text>
        </Stack>

        <SimpleGrid columns={1} gap={{ base: "6", md: "8" }}>
          {offers.map((offer) => (
            <Card.Root
              key={offer.title}
              borderWidth={offer.featured ? "2px" : "1px"}
              borderColor={offer.featured ? "brand.orange.500" : "border.muted"}
              bg={offer.featured ? "brand.orange.50" : "canvas.subtle"}
              boxShadow={offer.featured ? "xl" : "sm"}
              p="6"
              rounded="3xl"
            >
              <Flex direction="column" gap="6" h="full">
                <Stack gap="4">
                  <Flex direction="row" align="center" justify="space-between">
                    <Heading size="xl">{offer.title}</Heading>
                    {offer.featured && (
                      <Badge colorPalette="orange" variant="solid" rounded="full" px="3" py="1">
                        Polecane
                      </Badge>
                    )}
                  </Flex>

                  <Flex wrap="wrap" gap="4" color="muted">
                    {offer.details.map((detail) => (
                      <Flex key={`${offer.title}-${detail.value}`} align="center" gap="2.5" fontSize="sm">
                        <Icon as={detail.icon} color="orange.500" boxSize="4.5" flexShrink={0} />
                        <Text color="gray.700">{detail.value}</Text>
                      </Flex>
                    ))}
                  </Flex>

                  <Box color="muted" fontStyle="normal">
                    <Text color="muted">{offer.description}</Text>
                  </Box>
                </Stack>

                <Stack gap="4">
                  <Text fontSize="2xl" fontWeight="semibold">
                    {offer.price}
                  </Text>
                  <Stack as="ul" gap="3" pl="0">
                    {offer.benefits.map((benefit) => (
                      <Flex key={benefit} align="center" gap="2">
                        <Icon as={LuCheck} color="orange.500" boxSize="4" flexShrink={0} />
                        <Text color="muted">
                          {benefit}
                        </Text>
                      </Flex>
                    ))}
                  </Stack>
                </Stack>

                <NavLink to={`/zapisy/#${offer.slug}`}>
                    <Button
                        variant={offer.featured ? "solid" : "outline"}
                        colorPalette={"orange"}
                        size="lg"
                        w="full"
                    >
                        Sprawdź terminy
                    </Button>
                </NavLink>
              </Flex>
            </Card.Root>
          ))}
        </SimpleGrid>
      </Flex>
    </Box>
  )
}
